import React, { useState, useEffect } from 'react';
import { auth } from '../firebaseConfig';
import { sendEmailVerification } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';
import '../styles/VerifyEmail.css';

const VerifyEmail = () => {
  const [message, setMessage] = useState('');
  const [cooldown, setCooldown] = useState(0);
  const [checking, setChecking] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (cooldown > 0) {
      const timer = setInterval(() => setCooldown((prev) => prev - 1), 1000);
      return () => clearInterval(timer);
    }
  }, [cooldown]);

  const resendEmail = async () => {
    if (cooldown > 0) return;
    try {
      if (auth?.currentUser) {
        await sendEmailVerification(auth?.currentUser);
        setMessage('Verification email sent again. Check your inbox.');
        setCooldown(30);
      }
    } catch (err) {
      setMessage('Failed to resend. Try again later.');
    }
  };

  const checkVerification = async () => {
    if (!auth?.currentUser) return;

    setChecking(true);
    await auth?.currentUser.reload();

    if (auth?.currentUser.emailVerified) {
      setMessage('✅ Email verified! Redirecting...');
      setTimeout(() => navigate('/login'), 1500);
    } else {
      setMessage('❌ Not verified yet. Please check your inbox.');
    }

    setChecking(false);
  };

  return (
    <div className="login-container">
      <div className="login-wrapper">
        <div className="logo-side" onClick={() => navigate('/landing')} style={{ cursor: 'pointer' }}>
  <img
    src="/assets/theboxlogo.png"
    alt="TheBox Logo"
    className="login-logo"
  />
</div>


        <div className="glass-card">
          <h1>Verify Your Email</h1>
          <p>
            We've sent a verification link to <strong>{auth?.currentUser?.email}</strong>.
          </p>
          <p>Click the link in your email before continuing.</p>

          <button
            onClick={resendEmail}
            className="verify-button"
            disabled={cooldown > 0}
          >
            {cooldown > 0 ? `Wait ${cooldown}s` : 'Resend Verification Email'}
          </button>

          <button
            onClick={checkVerification}
            className="verify-button"
            disabled={checking}
          >
            {checking ? 'Checking...' : "I've Verified My Email"}
          </button>

          {message && <p className="status-message">{message}</p>}
        </div>

       
      </div>
    </div>
  );
};

export default VerifyEmail;
